import React, { PropsWithChildren } from "react";

const StoreMarker = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="63"
      fill="none"
      viewBox="0 0 47 63"
      style={{cursor:"pointer", transform:"translate(-50%,-100%)"}}
      {...props}>
      <path
        fill="#522398"
        d="M21.052 61.679c1.102 1.72 3.672 1.72 4.774 0C43.696 35.877 47 33.174 47 23.59 47 10.566 36.474 0 23.5 0 10.404 0 0 10.566 0 23.59c0 9.584 3.182 12.287 21.052 38.089z"></path>
      <path
        fill="#fff"
        d="M15.05 20.665a1.52 1.52 0 011.52-1.52h4.56a1.52 1.52 0 011.52 1.52v1.52h1.52v-1.52a1.52 1.52 0 011.519-1.52h4.56a1.52 1.52 0 011.52 1.52v1.52h2.279v-6.08a1.52 1.52 0 00-1.52-1.52H14.291a1.52 1.52 0 00-1.52 1.52v6.08h2.28v-1.52zm17.478 3.04H14.291a3.04 3.04 0 00-3.04 3.039v8.359a.76.76 0 00.76.76h.76a.76.76 0 00.76-.76v-2.28h19.757v2.28a.76.76 0 00.76.76h.76a.76.76 0 00.76-.76v-8.36a3.04 3.04 0 00-3.04-3.039zm.76 6.838H13.53v-3.8a.76.76 0 01.76-.76h18.237a.76.76 0 01.76.76v3.8z"></path>
    </svg>
  );
};

export default React.memo(StoreMarker);
